export const getTemplateClusterlets = (state) => {
    return (state.constructs.templated_clusterlet || []);
}


export const getConstructs = (state) => {
    return state.constructs
}

export const getDeletedTemplateAssociates = async (payload) => {
    const { item: selectedNode, state } = payload

    const item = JSON.parse(JSON.stringify(state.templated_clusterlet.find(i => i.id === selectedNode.id)))

    const connections = state.clusterletConnections.filter(edge => edge.source === item.id || edge.target === item.id)

    return { item, connections }

}

export const getTemplatecluserletMessages = (state) => {

    const messages = [];
    state.constructs.templated_clusterlet.forEach((clusterlet => {
        if (clusterlet.metajson !== undefined) {

            Object.keys(clusterlet.metajson?.messages).forEach((msg) => {
                messages.push({ ...clusterlet.metajson?.messages[msg], template: clusterlet?.name })

            })
        }
    }))

    const list = messages.map(item => {
        return { ...item, label: `${item.name} (from ${item.template})`, value: item.name, }
    })

    const alphabeticallyArrangedList = list.sort(function (a, b) {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    })
    return alphabeticallyArrangedList;

}

/** Convert template transaction to normal transaction */
export const normalizeTemplateTransaction = transactionName => ({
    id: "123",
    name: transactionName,
    type: 7,
    desc: "Transaction from template",
    invokedTransactions: [],
    templateTransactions: [],
    nestedTransactions: [],
    events: [],
    clusterlets: [],
    templateTransaction: true
})